<template>
  <div v-if="!hasPermission('List Schedule')">Você não tem permissão para acessar esta página!</div>
  <div v-else>
      <div
        :class="scheduleViewMode === 'board'
          ? 'schedules-board-viewport d-flex flex-column'
          : ''"
      >
      <div :class="['schedules-toolbar', scheduleViewMode === 'board' ? 'schedules-board-viewport__toolbar flex-shrink-0' : '']">
      <Toolbar classes="pt-2 pb-2 mb-3">
          <template v-slot:actions>
              <div class="schedules-toolbar__actions">
                        <button class="btn btn-icon schedules-toolbar__btn schedules-toolbar__btn--tasks" v-badge.warning="openTaskCount"
                                title="Tarefas" v-if="openTaskCount > 0"
                                @click="openTasks()">
                          <i class="bi bi-clipboard-check"></i>
                        </button>
                        <button class="btn btn-icon schedules-toolbar__btn schedules-toolbar__btn--tasks"
                                title="Tarefas" v-else
                                @click="openTasks()">
                          <i class="bi bi-clipboard-check"></i>
                        </button>
                        <button class="btn btn-icon btn-info schedules-toolbar__btn" v-badge.warning="waitingListsLenght"
                                title="Lista de espera" v-if="waitingListsLenght > 0"
                                data-bs-target="#modal_waiting_list" data-bs-toggle="modal">
                          <i class="bi bi-clock-history"></i>
                        </button>
                        <button class="btn btn-icon btn-info schedules-toolbar__btn"
                                title="Lista de espera" v-else
                                data-bs-target="#modal_waiting_list" data-bs-toggle="modal">
                          <i class="bi bi-clock-history"></i>
                        </button>
                        <button class="btn btn-icon btn-warning schedules-toolbar__btn"
                                title="Buscar agendamento" data-bs-target="#modal_search_schedules" data-bs-toggle="modal">
                          <i class="bi bi-search"></i>
                        </button>
                          <button class="btn btn-icon btn-primary schedules-toolbar__btn"
                                  title="Liberar horários"
                                  v-if="hasPermission('List Availability') ||
                                hasPermission('List AvailWeek') ||
                                hasPermission('List Availability Block')"
                                  @click.prevent="this.$router.push('/release-times')">
                              <i class="bi bi-unlock-fill"></i>
                          </button>
                          <button class="btn btn-icon btn-success schedules-toolbar__btn" aria-expanded="false"
                                  v-if="hasPermission('Store Schedule')"
                                  title="Novo agendamento" @click="openNewScheduleModal">
                              <i class="bi bi-plus-lg"></i>
                          </button>
                          <button class="btn btn-icon btn-danger schedules-toolbar__btn" aria-expanded="false"
                                  v-if="hasPermission('Cancel Batch Schedule') && hasPlanFeature('agenda.batch_cancel')"
                                  title="Cancelamento em lote" @click="openModalCancel = true">
                              <i class="bi bi-c-circle"></i>
                          </button>
                        <button class="btn btn-icon btn-secondary schedules-toolbar__btn"
                                title="Agendamento pelo paciente"
                                @click="openPatientSchedulingLink">
                          <i class="bi bi-box-arrow-up-right"></i>
                        </button>
              </div>
          </template>
      </Toolbar>
      </div>

      <TaskCards ref="taskCards" @open="openTasks" @count="openTaskCount = $event" />

      <SchedulesSpecialtyBoard
          ref="specialtyBoard"
          v-if="scheduleViewMode === 'board'"
          class="schedules-board-viewport__board flex-grow-1 min-h-0"
          @openSchedule="onOpenScheduleFromBoard"
          @openRecurrence="onOpenRecurrenceSessions"
          @refresh="onSpecialtyBoardRefresh"
          @change-mode="onBoardChangeMode"
      />
      <div class="px-3" v-show="scheduleViewMode === 'classic'">
        <ScheduleWorkspace
          ref="workspace"
          :filters="filters"
          :professional="professional"
          :unique-key="uniqueKey"
          @change-prof="onChangeProf"
          @change-spec="onChangeSpec"
          @open-schedule="onOpenScheduleFromBoard"
          @open-recurrence="onOpenRecurrenceSessions"
          @create-at="onDateClick"
          @open-board="toggleScheduleViewMode"
          @refresh="uniqueKey = date().unix().toString()"
        />
      </div>
      </div>

    <ModalSearchSchedule :modal-schedule-is-open="openModal"
      @openModalSchedule="onOpenScheduleFromSearch"
    />
    <ModalWaitingList
      :currentProf="this.filters.id_prof"
      :currentSpec="this.filters.id_spec"
      @onClickBtnCreateSchedule="this.currentWaitingList = $event"
      @onCloseModal="countWaitingLists()"
    />
    <TaskModal
      :open="tasksOpen"
      :focus-id="focusTaskId"
      @close="closeTasks"
      @changed="refreshTasks"
    />
    <CalendarModalSchedule
        :schedule-edit="scheduleEdit"
        :open-modal="openModal"
        :key="scheduleEdit?.id_sched || 'new'"
        :showHistory="scheduleEdit != null"
        :clickedDate="clickedDate"
        :currentProf="modalScheduleProf"
        :currentSpec="modalScheduleSpec"
        :waitingList="this.currentWaitingList"
        @onCloseModal="onCloseScheduleModal"
        @onSwitchSchedule="onSwitchSchedule"
        @onArriveSchedule="uniqueKey = this.date().unix().toString()"
        @onScheduleStore="uniqueKey = this.date().unix().toString()"
        @onScheduleCancel="uniqueKey = this.date().unix().toString()"
        @onConfirmSchedule="uniqueKey = this.date().unix().toString()"
        @onScheduleUpdate="uniqueKey = this.date().unix().toString()"
        @onStartAttendance="uniqueKey = this.date().unix().toString()"
        @onReopenSchedule="uniqueKey = this.date().unix().toString()"
        @onFinishSchedule="uniqueKey = this.date().unix().toString()"
    />
    <ModalScheduleRecurrenceSessions
        :open="openRecurrenceSessions"
        :sched-recur-id="recurrenceSchedId"
        :current-sched-id="recurrenceCurrentSchedId"
        @close="closeRecurrenceSessions"
        @view-schedule="onViewRecurrenceSchedule"
    />
    <ModalCancelSchedules
        :id-prof="filters.id_prof"
        :open-modal="openModalCancel"
        @onCloseModal="openModalCancel = false;"
    />

    <ScrollUpDown />
  </div>
</template>

<script>
import {mask} from "vue-the-mask";
import Permission from "../../helpers/permission";
import { hasPlanFeature as checkPlanFeature } from "../../helpers/platformFeature";
import SchedulesSpecialtyBoard from "./SchedulesSpecialtyBoard.vue";
import CalendarModalSchedule from "./ModalSchedule";
import ModalCancelSchedules from "./ModalCancelSchedules.vue";
import ModalWaitingList from "./ModalWaitingList.vue";
import TaskCards from "../tasks/TaskCards.vue";
import TaskModal from "../tasks/TaskModal.vue";
import ModalSearchSchedule from "./ModalSearchSchedule.vue";
import ModalScheduleRecurrenceSessions from "./ModalScheduleRecurrenceSessions.vue";
import ScheduleWorkspace from "./workspace/ScheduleWorkspace.vue";
import Toolbar from "../../components/layouts/auth/Toolbar.vue";
import ScrollUpDown from "../../components/ScrollUpDown.vue";
import BadgeDirective from 'primevue/badgedirective';
import http from "../../helpers/http";
import {
  loadScheduleWorkspacePrefs,
  saveScheduleWorkspacePrefs,
} from "../../helpers/scheduleWorkspacePrefs";

export default {
  name: "Schedules",
  directives: {
    mask,
    'badge': BadgeDirective
  },
  components: {
    ModalCancelSchedules,
    CalendarModalSchedule,
    Toolbar,
    ScrollUpDown,
    ModalSearchSchedule,
    ModalWaitingList,
    TaskCards,
    TaskModal,
    SchedulesSpecialtyBoard,
    ModalScheduleRecurrenceSessions,
    ScheduleWorkspace,
  },
  data() {
    const prefs = loadScheduleWorkspacePrefs({
      userId: this.$store.state.auth.user?.id_user,
      placeId: this.$store.state.auth.place?.id_place,
    });
    return {
      uniqueKey: null,
      filters: {
        status: null,
        id_prof: null,
        id_spec: null,
        id_paymeth: null,
        id_insurance: null,
      },
      professional: null,
      openModal: false,
      clickedDate: null,
      openModalCancel: false,
      scheduleEdit: null,
      waitingListsLenght: 0,
      openTaskCount: 0,
      tasksOpen: false,
      focusTaskId: null,
      currentWaitingList: 0,
      scheduleViewMode: prefs.viewMode,
      modalContextProf: null,
      modalContextSpec: null,
      openRecurrenceSessions: false,
      recurrenceSchedId: null,
      recurrenceCurrentSchedId: null,
    }
  },
  computed: {
    professionals() {
      return this.$store.state.auth.professionals;
    },
    place() {
      return this.$store.state.auth.place;
    },
    userAuth() {
      return this.$store.state.auth.user;
    },
    modalScheduleProf() {
      return this.modalContextProf ?? this.filters.id_prof;
    },
    modalScheduleSpec() {
      return this.modalContextSpec ?? this.filters.id_spec;
    },
  },
  mounted() {
    if (this.professionals.length === 1) {
      let prof = this.professionals[0];
      this.filters.id_prof = prof.id_prof;
      setTimeout(() => this.onChangeProf(prof), 800);
    }

    this.$store.dispatch('auth/loadProfessionals');
  },
  methods: {
    date: moment,
    onChangeProf(prof) {
      this.professional = prof;
      this.filters.id_spec = null;
      this.countWaitingLists();
    },
    onChangeSpec() {
      this.countWaitingLists();
    },
    hasPermission(permission) {
      return Permission.has(permission);
    },
    hasPlanFeature(slug) {
      return checkPlanFeature(slug);
    },
    openTasks(taskId = null) {
      this.focusTaskId = typeof taskId === 'number' ? taskId : null;
      this.tasksOpen = true;
    },
    closeTasks() {
      this.tasksOpen = false;
      this.focusTaskId = null;
      this.refreshTasks();
    },
    refreshTasks() {
      this.$refs.taskCards?.load();
    },
    countWaitingLists() {
      setTimeout(() => {
        http.get(`/places/${this.place.id_place}/waiting-lists/count`, {params: this.filters}).then((response) => {
          this.waitingListsLenght = response.data;
        });
      }, 200);
    },
    onCloseScheduleModal() {
      this.openModal = false;
      this.scheduleEdit = null;
      this.modalContextProf = null;
      this.modalContextSpec = null;
    },
    openNewScheduleModal() {
      this.modalContextProf = null;
      this.modalContextSpec = null;
      this.scheduleEdit = null;
      this.openModal = true;
    },
    onDateClick(date) {
      this.modalContextProf = null;
      this.modalContextSpec = null;
      this.scheduleEdit = null;
      this.openModal = true;
      this.clickedDate = date;
    },
    onSpecialtyBoardRefresh() {
      this.uniqueKey = this.date().unix().toString();
      this.$nextTick(() => this.$refs.specialtyBoard?.loadBoard?.());
    },
    toggleScheduleViewMode() {
      this.scheduleViewMode = this.scheduleViewMode === 'classic' ? 'board' : 'classic';
      saveScheduleWorkspacePrefs({ viewMode: this.scheduleViewMode }, {
        userId: this.userAuth?.id_user,
        placeId: this.place?.id_place,
      });
    },
    onBoardChangeMode(mode) {
      this.toggleScheduleViewMode();
      this.$refs.workspace?.setMode(mode);
    },
    onOpenScheduleFromBoard(schedule) {
      if (schedule && schedule.id_sched) {
        this.modalContextProf = schedule.id_prof;
        this.modalContextSpec = schedule.id_spec;
      } else {
        this.modalContextProf = null;
        this.modalContextSpec = null;
      }
      this.scheduleEdit = schedule;
    },
    onOpenScheduleFromSearch(schedule) {
      this.onOpenScheduleFromBoard(schedule);
      this.openModal = true;
    },
    onSwitchSchedule(schedule) {
      this.onOpenScheduleFromBoard(schedule);
      this.openModal = true;
    },
    onOpenRecurrenceSessions(schedule) {
      if (!schedule?.sched_recur_id) {
        return;
      }
      this.recurrenceSchedId = schedule.sched_recur_id;
      this.recurrenceCurrentSchedId = schedule.id_sched;
      this.openRecurrenceSessions = true;
    },
    closeRecurrenceSessions() {
      this.openRecurrenceSessions = false;
      this.recurrenceSchedId = null;
      this.recurrenceCurrentSchedId = null;
    },
    onViewRecurrenceSchedule(schedule) {
      this.closeRecurrenceSessions();
      this.onSwitchSchedule(schedule);
    },
    openPatientSchedulingLink() {
      const url = `https://patient.ubbimed.com.br/place/${this.place.id_place}`;
      window.open(url, '_blank');
    }
  }
}
</script>

<style scoped>
/*
 * Modo quadro: altura = viewport − header − footer (conteúdo já fica abaixo do header).
 * Evita scroll vertical na página e mantém a barra de rolagem horizontal visível.
 */
.schedules-board-viewport {
  /* Header + footer aproximados; aumente (ex. 12.5rem) se ainda houver scroll vertical na página */
  --schedules-board-chrome: 11rem;
  box-sizing: border-box;
  min-height: 0;
  height: calc(100svh - var(--schedules-board-chrome));
  max-height: calc(100svh - var(--schedules-board-chrome));
  height: calc(100dvh - var(--schedules-board-chrome));
  max-height: calc(100dvh - var(--schedules-board-chrome));
  overflow: hidden;
  overscroll-behavior-y: contain;
}

.schedules-toolbar :deep(.toolbar) {
  margin-bottom: 0.75rem !important;
}
.schedules-toolbar__actions {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 0.4rem;
}
.schedules-toolbar__btn {
  width: 2.5rem !important;
  height: 2.5rem !important;
  min-height: 2.5rem !important;
  padding: 0 !important;
  margin: 0 !important;
  border-radius: 0.5rem;
  display: inline-flex !important;
  align-items: center;
  justify-content: center;
}
.schedules-toolbar__btn i {
  font-size: 1.15rem;
  line-height: 1;
  padding: 0;
  margin: 0;
}
.schedules-toolbar__btn--tasks {
  background: #0f766e;
  border-color: #0f766e;
  color: #fff;
}
.schedules-toolbar__btn--tasks i {
  color: #fff;
}
.schedules-toolbar__btn--tasks:hover,
.schedules-toolbar__btn--tasks:focus {
  background: #115e59;
  border-color: #115e59;
  color: #fff;
}
.schedules-toolbar__btn--tasks:hover i,
.schedules-toolbar__btn--tasks:focus i {
  color: #fff;
}
</style>